import { create } from 'zustand';

interface HelperDialogState {
  open: boolean;
  /** Avoid repeating the startup prompt in the same browser session. */
  startupPromptShown: boolean;
  show: () => void;
  close: () => void;
  showStartupPromptOnce: () => void;
}

export const useHelperDialogStore = create<HelperDialogState>((set, get) => ({
  open: false,
  startupPromptShown: false,
  show: () => set({ open: true }),
  close: () => set({ open: false }),
  showStartupPromptOnce: () => {
    if (get().startupPromptShown) {
      return;
    }
    set({ startupPromptShown: true, open: true });
  },
}));
